var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"relative flex items-center justify-center h-8 px-4 rounded-full outline-none focus:outline-none",class:[_vm.className],attrs:{"disabled":_vm.disabled}},[_c('span',{staticClass:"block"},[(_vm.icon)?_c('Icon',{staticClass:"mr-3",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }